import { render, staticRenderFns } from "./MainHeaderSchMessages.vue?vue&type=template&id=3ce627a0&scoped=true&lang=pug"
import script from "./MainHeaderSchMessages.vue?vue&type=script&lang=js"
export * from "./MainHeaderSchMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce627a0",
  null
  
)

export default component.exports